export const SELECTOR =
  '[tabindex]:not([tabindex="-1"]), :is(a[href], summary), :is(input, button, select, textarea):not([tabindex="-1"], [type="hidden"], :disabled)'

/** @type {import('svelte/action').Action<HTMLElement, { selector?: string, disabled?: boolean }|undefined>} */
export function capture(element, opts = {}) {
  let { selector = SELECTOR, disabled = false } = opts

  const onkeydown = (event) => {
    if (event.key !== 'Tab' || disabled) return

    /** @type {HTMLElement[]} */
    const focusables = Array.from(element.querySelectorAll(selector))
    const active = document.activeElement

    // @ts-ignore
    const index = focusables.indexOf(active)
    if (index === -1) {
      if (!focusables.length) element.focus()
      return
    }

    const next = index + (event.shiftKey ? -1 : 1)
    if (next >= focusables.length) {
      focusables.at(0).focus()
      event.preventDefault()
    } else if (next === -1) {
      focusables.at(-1).focus()
      event.preventDefault()
    }
  }

  document.addEventListener('keydown', onkeydown)

  return {
    update(opts) {
      if (opts?.selector) selector = opts.selector
      if (opts?.disabled != null) disabled = opts.disabled
    },
    destroy() {
      document.removeEventListener('keydown', onkeydown)
    }
  }
}
